import { render, staticRenderFns } from "./newsDetailMobile.vue?vue&type=template&id=544894e1&scoped=true"
import script from "./newsDetailMobile.vue?vue&type=script&lang=js"
export * from "./newsDetailMobile.vue?vue&type=script&lang=js"
import style0 from "./newsDetailMobile.vue?vue&type=style&index=0&id=544894e1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544894e1",
  null
  
)

export default component.exports